import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _GltfCatalogItem;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, observable, makeObservable } from "mobx";
import GltfMixin from "../../../ModelMixins/GltfMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import GltfCatalogItemTraits from "../../../Traits/TraitsClasses/GltfCatalogItemTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import CesiumIonMixin from "../../../ModelMixins/CesiumIonMixin";
let GltfCatalogItem = (_class = (_GltfCatalogItem = class GltfCatalogItem extends UrlMixin(CesiumIonMixin(GltfMixin(CreateModel(GltfCatalogItemTraits)))) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "hasLocalData", _descriptor, this);
    makeObservable(this);
  }
  get type() {
    return GltfCatalogItem.type;
  }
  get gltfModelUrl() {
    if (this.ionResource) {
      return this.ionResource;
    } else {
      return this.url;
    }
  }
  forceLoadMetadata() {
    return this.loadIonResource();
  }
  setFileInput(file) {
    const dataUrl = URL.createObjectURL(file);
    this.setTrait(CommonStrata.user, "url", dataUrl);
    this.hasLocalData = true;
  }
}, _defineProperty(_GltfCatalogItem, "type", "gltf"), _GltfCatalogItem), _applyDecoratedDescriptor(_class.prototype, "gltfModelUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "gltfModelUrl"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "hasLocalData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setFileInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileInput"), _class.prototype), _class);
export { GltfCatalogItem as default };